import { VideoEffect, VideoEffectsMode } from './types';

export const EFFECTS_DISABLED: VideoEffect = {
  enabled: false,
  mode: VideoEffectsMode.NONE,
};

export const PRESENTATION_V3_TIMEOUTS: PresentationTransitions = {
  presentationIconFadeIn: 1000,
  backgroundFadeOutTimeout: 3500,
  backgroundFadeInTimeout: 1000,
  audioFadeTimeout: 4000,
  transitionLoadTimeout: 1500,
};

export const DEFAULT_GROUP_SHARE_TIMEOUTS: GroupShareTransitions = {
  backgroundFadeAudienceTransition: 1000,
  backgroundFadePresenterTransition: 1500,
  darkModeTimeout: 1000,
  presentationAudienceTransition: 1500,
  presentationPresenterTransition: 2500,
};

export interface GroupShareTransitions {
  backgroundFadeAudienceTransition: number;
  backgroundFadePresenterTransition: number;
  darkModeTimeout: number;
  presentationAudienceTransition: number;
  presentationPresenterTransition: number;
}

export interface PresentationTransitions {
  presentationIconFadeIn: number;
  backgroundFadeOutTimeout: number;
  backgroundFadeInTimeout: number;
  audioFadeTimeout: number;
  transitionLoadTimeout: number;
}
